import * as yup from 'yup';

const TransferSchema = yup.object().shape({
    fromBankAccountId: yup.number().required().moreThan(0),
    fromLotId: yup.number().required().moreThan(0),
    toBankAccountId: yup.number().required().moreThan(0),
    toLotId: yup.number().required().moreThan(0),
    amount: yup.number().required().moreThan(0),
});

export default TransferSchema;
